import { VERSANT_BASE_URL, SE_BASE_URL, SEP_HELP_BASE_URL } from "./constants";

export const links = {
  home: { href: "/", label: "Home" },
  contact: {
    href: `${SE_BASE_URL}/play/demo#form-section`,
    label: "Contact Us",
  },
  terms: { href: `${SE_BASE_URL}/terms`, label: "Terms of Use" },
  privacy: {
    href: `${VERSANT_BASE_URL}/privacy?intake=LocalLive`,
    label: "Privacy Policy",
  },
  cookies: {
    href: `${VERSANT_BASE_URL}/privacy/cookies#accordionheader3`,
    label: "Ad Choices",
  },
  caNotice: {
    href: `${VERSANT_BASE_URL}/privacy/california-consumer-privacy-act?intake=LocalLive`,
    label: "CA Notice",
  },
  helpCenter: {
    href: `${SEP_HELP_BASE_URL}/?_gl=1*mpa37n*_ga*MTgxNzI5MTA2Ny4xNzU4NjUxODc0*_ga_P3VED716HZ*czE3NjUzMDA1NzckbzI3JGcxJHQxNzY1MzAzMDAxJGo2MCRsMCRoMA..`,
    label: "Help Center",
  },
};

export default links;
